import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

var isPlainObject = function isPlainObject(value) {
  return value instanceof Object && Object.getPrototypeOf(value) == Object.prototype;
};

var applyObjectChanges = function applyObjectChanges(target, changes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.keys(changes).forEach(function (key) {
    if (!options.requireExistingKeys || target.hasOwnProperty(key)) {
      if (options.mergeValues && isPlainObject(changes[key])) {
        target[key] = target[key] || {};
        applyObjectChanges(target[key], changes[key]);
      } else {
        target[key] = changes[key];
      }
    }
  });
};

var ModuleConfig = /*#__PURE__*/function () {
  function ModuleConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ModuleConfig);

    _defineProperty(this, "_options", void 0);

    this._options = _objectSpread2({}, config);
  }

  _createClass(ModuleConfig, [{
    key: "exists",
    value: function exists(key) {
      return this._options.hasOwnProperty(key);
    }
  }, {
    key: "isNullOrWhitespace",
    value: function isNullOrWhitespace(key) {
      if (this.exists(key)) {
        var value = this.get(key);

        if (typeof value === "string") {
          return value.trim() === "";
        }

        return value === undefined || value === null;
      }

      return false;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._options[key];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._options;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this._options[key] = value;
    }
  }, {
    key: "setAll",
    value: function setAll(config) {
      var requireExistingKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var mergeValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      applyObjectChanges(this._options, config, {
        requireExistingKeys: requireExistingKeys,
        mergeValues: mergeValues
      });
    }
  }]);

  return ModuleConfig;
}();

var ModuleIntegration = /*#__PURE__*/function () {
  function ModuleIntegration(type) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ModuleIntegration);

    _defineProperty(this, "_type", void 0);

    _defineProperty(this, "_config", void 0);

    _defineProperty(this, "_actions", void 0);

    _defineProperty(this, "_events", void 0);

    this._type = type;
    this._config = config instanceof ModuleConfig ? config : new ModuleConfig(config);
    this._actions = {};
    this._events = {};
  }

  _createClass(ModuleIntegration, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "addAction",
    value: function addAction(key, action) {
      this._actions[key] = action;
    }
  }, {
    key: "addActions",
    value: function addActions(actions) {
      this._actions = _objectSpread2(_objectSpread2({}, this._actions), actions);
    }
  }, {
    key: "findAction",
    value: function findAction(key) {
      return this._actions.hasOwnProperty(key) ? this._actions[key] : undefined;
    }
  }, {
    key: "addEvent",
    value: function addEvent(key, event) {
      this._events[key] = event;
    }
  }, {
    key: "addEvents",
    value: function addEvents(events) {
      this._events = _objectSpread2(_objectSpread2({}, this._events), events);
    }
  }, {
    key: "findEvent",
    value: function findEvent(key) {
      return this._events.hasOwnProperty(key) ? this._events[key] : undefined;
    }
  }]);

  return ModuleIntegration;
}();

var ModuleIntegrationPipeline = /*#__PURE__*/function () {
  function ModuleIntegrationPipeline() {
    _classCallCheck(this, ModuleIntegrationPipeline);

    _defineProperty(this, "_integrations", void 0);

    _defineProperty(this, "_default", void 0);

    this._integrations = [];
    this._default = undefined;
  }

  _createClass(ModuleIntegrationPipeline, [{
    key: "exists",
    value: function exists(integration) {
      return this._integrations.some(function (i) {
        return integration.type === i.type;
      });
    }
  }, {
    key: "any",
    value: function any() {
      return this._integrations.length > 0;
    }
  }, {
    key: "add",
    value: function add(integration, setDefault) {
      if (!this.exists(integration)) this._integrations.push(integration);

      if (setDefault || this._integrations.length === 1) {
        this._default = integration;
      }
    }
  }, {
    key: "setDefault",
    value: function setDefault(integration) {
      if (this.exists(integration)) this._default = integration;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      return this._default;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _toConsumableArray(this._integrations);
    }
  }]);

  return ModuleIntegrationPipeline;
}();

export { ModuleConfig, ModuleIntegration, ModuleIntegrationPipeline };
